const MASKED_LINKS_INIT_DONE_ATTR = 'data-ents-masked-links-initialized';

export const openMaskedLink = (event) => {
  const href = event.currentTarget.getAttribute('data-href');
  const target = event.currentTarget.getAttribute('data-target');
  if (href) {
    event.preventDefault();
    if (target === '_blank') {
      window.open(href, target);
    } else {
      window.location.href = href;
    }
  }
};

export const initMaskedLinks = (container) => {
  if (container.getAttribute(MASKED_LINKS_INIT_DONE_ATTR) === 'true') return;
  container.querySelectorAll('button[data-href]')
    .forEach((element) => {
      element.addEventListener('click', openMaskedLink);
    });
  container.setAttribute(MASKED_LINKS_INIT_DONE_ATTR, 'true');
};
